import {Grid} from '@logistics-frontend/blocks'
import {Button} from '@logistics-frontend/blocks/lpc/button'
import {Divider} from '@logistics-frontend/blocks/lpc/divider'
import {useI18n} from '@logistics-frontend/core/i18n'
import {makeStyles} from '@material-ui/core/styles'
import clsx from 'clsx'
import React, {useCallback} from 'react'

import {Address, Props as AddressProps} from '../../../shared/address'
import {ExtraData} from './extra-data'

type Props = AddressProps & {
  onRemove: (index: number) => void
  onClear: (index: number) => void
}

const useClasses = makeStyles(theme => ({
  title: {
    fontSize: 18,
    // проблема старой темы
    // eslint-disable-next-line
    fontWeight: theme.typography.fontWeightMedium as any,
  },
  circle: {
    width: 14,
    height: 14,
    border: '3px solid',
    borderRadius: '50%',
  },
  circleRed: {
    borderColor: '#FB482D',
  },
  divider: {
    [theme.breakpoints.down('sm')]: {
      marginTop: theme.spacing(2),
    },
  },
}))

const FullAddress: React.FC<Props> = ({index, length, onRemove, onClear}) => {
  const t = useI18n()
  const classes = useClasses()
  const isSource = index === 0

  const clickHandler = useCallback(
    () => (isSource || length <= 2 ? onClear(index) : onRemove(index)),
    [isSource, index, length, onClear, onRemove],
  )

  const placeholder = isSource
    ? t('order.form.address.source_placeholder', 'Адрес отправителя')
    : t('order.form.address.recipient_placeholder', 'Адрес получателя')
  const title = isSource ? t('order.form.address.from_title', 'Откуда') : t('order.form.address.to_title', 'Куда')

  return (
    <>
      <Grid spacing={1} container>
        <Grid alignItems="center" spacing={1} container item>
          <Grid item>
            <Grid className={clsx(classes.circle, {[classes.circleRed]: isSource})} />
          </Grid>
          <Grid className={classes.title} item xs>
            {title}
          </Grid>
          <Grid>
            <Button onClick={clickHandler} size="small" startIcon="✕">
              {t('order.form.address.clear', 'Очистить')}
            </Button>
          </Grid>
        </Grid>
        <Grid spacing={1} container item>
          <Grid xs={12} item>
            <Address index={index} length={length} placeholder={placeholder} />
          </Grid>
          <ExtraData index={index} length={length} />
        </Grid>
      </Grid>
      {index < length - 1 && <Divider className={classes.divider} />}
    </>
  )
}

export default FullAddress
